<template>
  <div id="carta-iframe">
    <img
      :key="'images' + index"
      :src="img.image"
      alt
      class="image-carta"
      v-for="(img, index) in images"
    />
  </div>
</template>
<script>
export default {
  props: ['images'],
  mounted () {
    if (this.params.bannerActiveMenuDigital === 1) {
      this.$store.commit('whiteLabel:setMenuIdBanner', this.images[0].menuId);
    }
  }
};
</script>
<style lang="scss">
#carta-iframe {
  margin-top: 60px;
  overflow: auto;
  width: 100%;
  height: 100%;
  .image-carta {
    width: 100%;
    height: auto;
  }
}
</style>
